export class PrintSet {
    Id: number = null;
    Name: string = null;
    Printer: string = null;
    LabelName: string = null;
    LblTemplateId: number = null;
    CreatedDtTm: Date = null;
    IsActive: boolean = true;
}
